import interact from 'interactjs';

export class DragOptions {

  allowFrom: string;
  modifiers: any[];
  inertia: boolean;

  constructor(floating: boolean) {

    this.allowFrom = '.window-toolbar';
    this.modifiers = [
      interact.modifiers.restrict({
        restriction: 'body',
        elementRect: {top: 0, left: 0, bottom: 0, right: 0},
        endOnly: floating,
      })
    ];

    this.inertia = floating;

  }

}
